/** Path of the isolated maintenance page inside this SPA. */
export const MAINTENANCE_PATH = "/maintenance";

/**
 * Where the maintenance gate sends a visitor, keeping the language they asked for.
 *
 * The language-prefixed URLs (`/ar`, `/fr`, `/en`) belong to the public site,
 * which is a different app: this SPA has no route for them, so redirecting to
 * `/ar/maintenance` would fall through to the NotFound page. The resolved
 * language is therefore carried as `?language=`, which is the first thing
 * `SessionProvider` reads — so the redirected URL still resolves to Arabic when
 * it is reloaded or shared, not only during the current render.
 *
 * With no resolved language the bare `/maintenance` path is returned unchanged,
 * so a direct hit on it keeps working and falls back as before.
 */
export const maintenanceRedirectPath = (language?: string | null): string =>
  language
    ? `${MAINTENANCE_PATH}?language=${encodeURIComponent(language)}`
    : MAINTENANCE_PATH;
